// extracted by mini-css-extract-plugin
export default {"wrapper":"_dac83105","thumbsWrapper":"_cbaab210","large":"_1195f4ab","medium":"_3f1f130b","small":"_7d107e09","displayWrapper":"_2048a75f","item":"_d77b3f03"};